// extracted by mini-css-extract-plugin
module.exports = {"socialsContainer":"styles_socialsContainer__3LO6p","socialLogo":"styles_socialLogo__18m6d"};